
<div class="d-flex justify-content-center">
<h3>Cart</h3>
</div>
<div class="container">
    <hr>
</div>

<div class="container d-flex justify-content-center">
  <div *ngIf="!carts || carts.length === 0">
    <p>Your cart is empty.</p>
</div>
<div *ngIf="carts && carts.length > 0">
    <table class="table">
        <thead class="thead-dark">
          <tr>
            <th scope="col"></th>
            <th scope="col">Pizza</th>
            <th scope="col">Ingredients</th>
            <th scope="col">Quantity</th>
            <th scope="col">Price</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of carts">
            <th scope="row" class="cart-body">
                <img [src]="item.imgUrl" class="cart-img"/>
            </th>
            <td class="cart-body">{{ item.name }}</td>
            <td class="cart-body">{{ item.ingredients }}</td>
            <td class="cart-body">{{ item.quantity }}</td>
            <td class="cart-body">{{ item.price | currency:'EUR' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
</div>